import { render, staticRenderFns } from "./addClientsListForm.vue?vue&type=template&id=5fccd029&"
import script from "./addClientsListForm.vue?vue&type=script&lang=js&"
export * from "./addClientsListForm.vue?vue&type=script&lang=js&"
import style0 from "./addClientsListForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports